module.exports = __webpack_public_path__ + "static/media/dripicons-v2.0253a9a5.svg";